import { render, staticRenderFns } from "./detailsReturner.vue?vue&type=template&id=2ea9086a&scoped=true"
import script from "./detailsReturner.vue?vue&type=script&lang=js"
export * from "./detailsReturner.vue?vue&type=script&lang=js"
import style0 from "./detailsReturner.vue?vue&type=style&index=0&id=2ea9086a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9086a",
  null
  
)

export default component.exports